export const FIGTREE_FONT = 'Figtree';
export const ROBOTO_MONO_FONT = 'Roboto Mono';
